export default function getSubjectExtraInfo(subject) {
	let fields = [];

	if(subject.Teacher) {
		fields.push(subject.Teacher);
	} else if(subject['Home Room']) {
		fields.push(subject['Home Room']);
	}

	if(subject.Grade) {
		fields.push(subject.Grade);
	}

	return fields.join(' - ');
}